import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import PageLoader from './components/PageLoader';
import ItemSetupUploadList from './pages/ItemSetupUploadList';

const WebimAuthEntry = lazy(() => import('./pages/WebimAuthEntry'));

export default function App() {
  return (
    <>
      <Toaster
        position="top-center"
        gutter={10}
        containerClassName="app-toaster"
        toastOptions={{
          duration: 5000,
          className: 'app-toast',
          style: {
            fontSize: '12px',
            fontFamily: 'Arial, Helvetica, sans-serif',
            maxWidth: 'min(440px, calc(100vw - 24px))',
          },
          success: {
            duration: 4000,
            className: 'app-toast app-toast--success',
          },
          error: {
            duration: 8000,
            className: 'app-toast app-toast--error',
          },
        }}
      />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<WebimAuthEntry />} />
          <Route path="/itemuploadlist" element={<ItemSetupUploadList />} />
        </Routes>
      </Suspense>
    </>
  );
}
